import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    borderLeft: `1px solid ${theme.palette.text.hint}`
  },
  header: {
    display: "flex",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    padding: "0 24px",
    gap: 40,
    boxShadow: "none",
    [theme.breakpoints.down("xs")]: {
      gap: 20,
      padding: "0 16px"
    }
  },
  searchWrapper: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      width: "30%"
    }
  },
  searchIcon: {
    fontSize: 17,
    color: theme.palette.text.secondary
  },
  search: {
    width: 323,
    "&$searchInputFocused $searchInputNotchedOutline": {
      borderWidth: 1
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  searchInput: {
    height: 30,
    width: "100%",
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 14,
    lineHeight: 1
  },
  searchInputFocused: {},
  searchInputNotchedOutline: {
    borderWidth: 1
  },
  appPageContent: {
    backgroundColor: "#fff",
    zIndex: theme.zIndex.app.sidebar,
    boxShadow: "none"
  },
  tabs: {
    boxShadow: "none",
    minHeight: theme.heightDesktopPageHeader,
    height: theme.heightDesktopPageHeader,
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.secondary.dark
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      "& > *": {
        flex: "initial"
      }
    }
  },
  tab: {
    minHeight: theme.heightDesktopPageHeader,
    minWidth: "unset",
    fontSize: "16px",
    fontFamily: "SuisseIntlMedium",
    color: theme.palette.text.secondary,
    paddingLeft: 24,
    paddingRight: 24
  },
  tabSelected: {
    color: theme.palette.secondary.dark
  },
  content: {
    maxWidth: "800px",
    margin: "48px 0 0",
    padding: "28px 16px 16px 16px",
    flex: "auto",
    overflow: "auto"
  }
}));
